<template>
  <div class="slider-container">
    <div class="slider " :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <!-- Render the images in a loop -->
      <div
        v-for="(image, index) in images"
        :key="index"
        :class="['slide', { active: index === currentIndex }]"
      >
        <img :src="image" :alt="'Slide ' + (index + 1)" />
      </div>
    </div>

    <!-- Left and right navigation buttons -->
    <button @click="prevSlide" class="nav-button left">‹</button>
    <button @click="nextSlide" class="nav-button right">›</button>

    <!-- Dots navigation -->
    <div class="dots">
      <span
        v-for="(image, index) in images"
        :key="index"
        :class="{ active: index === currentIndex }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
import image1 from '@/assets/image19.jpg'; // Update these paths based on your assets

import image13 from '@/assets/image15.jpg';
// import image14 from '@/assets/image13.jpg';
import image15 from '@/assets/image41.jpeg';

import image18 from '@/assets/image18.jpg';
// Update these paths based on your assets

import image40 from '@/assets/image40.jpg';
import image41 from '@/assets/image41.jpeg'; // Update these paths based on your assets
import image42 from '@/assets/image42.jpg';
import image43 from '@/assets/image43.jpeg';
import image50 from '@/assets/image50.jpg';
import image45 from '@/assets/image45.jpeg';

import image46 from '@/assets/image46.jpeg';
// import image47 from '@/assets/image47.jpg'; // Update these paths based on your assets
import image48 from '@/assets/image48.jpg';

export default {
  data() {
    return {
      currentIndex: 0,
      images: [
				image1,image13,image15,image18,image40,image41,image42,image43,image45,image46,image48,image50
      ],
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
  },
};
</script>

<style scoped>
/* .slider-container {
  position: relative;
  width: 100%;
  max-height: 700px;
  margin: 0 auto;
  overflow: hidden;
}

.slider {
  display: flex;
  transition: transform 0.5s ease-in-out; 
}

.slide {
  min-width: 100%; 
	
  transition: opacity 0.5s ease-in-out;
}


.slide.active {
  opacity: 1;
}

img {
  width: 100%; 
  height: auto;
  object-fit: cover; 
  display: block; 
} */

/* Container for the slider */
.slider-container {
  position: relative;
  width: 100%;
  max-height: 700px; /* Set max height for larger screens */
  margin: 0 auto;
  overflow: hidden;
  transition: margin-top 0.3s ease-in-out; /* Smooth transition for margin changes */
}

/* Slider itself */
.slider {
  display: flex;
  transition: transform 0.5s ease-in-out; /* Transition effect for sliding */
  width: 100%;
}

/* Individual slide */
.slide {
  min-width: 100%; /* Each slide should take full width */
  transition: opacity 0.5s ease-in-out;
}

/* Active slide style */
.slide.active {
  opacity: 1;
}

/* Image styles */
img {
  width: 100%; /* Ensure the image takes full width of the slide */
  height: auto; /* Maintain aspect ratio */
  object-fit: cover; /* Cover the entire area without distortion */
  display: block; /* Remove bottom space */
}

/* Media Query for smaller screens (e.g., mobile or tablet) */
@media (max-width: 768px) {
  .slider-container {
    max-height: 600px; /* Adjust max-height for smaller screens */
     /* Add a top margin to prevent images from being hidden by the top bar */
  }

  /* As the screen shrinks, the image takes more space */
  img {
    object-fit: cover; /* Maintain cover behavior */
    width: 100%;
    height: 100%; /* Allow image to fill the height of the container */
  }
}

/* Media Query for very small screens (e.g., phones in portrait mode) */
@media (max-width: 480px) {
  .slider-container {
    max-height: 500px; /* Further reduce the max-height */
    /* Further increase the top margin for smaller screens */
  }

  /* Increase the size of the image further for very small screens */
  img {
    width: 100%;
    height: 100%; /* Make the image fill the available height */
    object-fit: cover; /* Ensure the image covers the container without distortion */
  }
}





.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  z-index: 10;
}

.nav-button.left {
  left: 10px;
}

.nav-button.right {
  right: 10px;
}

.dots {
  text-align: center;
  margin-top: 10px;
}

.dots span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: gray;
  border-radius: 50%;
  cursor: pointer;
}

.dots span.active {
  background-color: black;
}


</style>
